import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import UserLayout from '../../Shared/UserLayout';
import DataContainer from '../../Shared/DataContainer';
import LoadingButton from '../../Shared/LoadingButton';
import TextInput from '../../Shared/TextInput';
import { can } from '../../utils';

const CheckOut = () => {
     const { auth, errors, data } = usePage().props;
     console.log(data);
     const [values, setValues] = useState({
          cart: (data.cart)?data.cart.id:0,
          details: (data.cart)?data.cart.details:[],
          name: (data.cart) ? data.cart.pickup.name:'',
          phone: (data.cart) ? data.cart.pickup.phone:'',
          address: (data.cart) ? data.cart.pickup.address:'',
          destination: (data.cart) ? data.cart.destination:'',
          is_delivery: (data.cart)?data.cart.is_delivery:false,
          is_pickup: (data.cart)?data.cart.is_pickup:false,
     });

     return (
          <React.Fragment key="security-index">
               <Helmet>
                    <title>CheckOut</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <span className="text-md text-gray-700 leading-tight">Check Out</span>
               </div>
               {!data.cart && (<div className="col-span-12 bg-blue-100 text-blue-600 border border-blue-500 px-4 py-4 text-center">No Item added to the cart yet please go to the <InertiaLink className="font-bold" href={route('catalog.index')}>Check Out</InertiaLink>.</div>)}
               {data.cart && (<div className="col-span-12 flex my-6">
                    <div className="w-full flex flex-col w-full p-8 text-gray-800 bg-white shadow-lg pin-r pin-y">
                              <div className="flex-1">
                                   <table className="w-full text-sm lg:text-base" cellSpacing="0">
                                        <thead>
                                             <tr className="h-12 uppercase">
                                                  <th className="hidden md:table-cell"></th>
                                                  <th className="text-left">{data.cart.caption.product}</th>
                                                  <th className="lg:text-right text-left pl-5 lg:pl-0">
                                                       <span className="lg:hidden" title="Quantity">{data.cart.caption.short_qty}</span>
                                                       <span className="hidden lg:inline">{data.cart.caption.quantity}</span>
                                                  </th>
                                                  <th className="hidden text-right md:table-cell">{data.cart.caption.price}</th>
                                                  <th className="text-right">{data.cart.caption.total_price}</th>
                                             </tr>
                                        </thead>
                                        <tbody>
                                             {values.details.map(({id, name, code, product, quantity, currency, price, newprice, packs, image, update}, i) => {
                                                  return <tr className="pt-4 border-b border-gray-300" key={id}>
                                                       <td className="hidden pb-4 md:table-cell">
                                                            <a href="#">
                                                                 {image && (<img src={image} alt={name} className="w-12 rounded" alt="Thumbnail" />)}
                                                                 {!image && (<img className="w-12" src={`https://ui-avatars.com/api/?name=${name}&amp;color=7F9CF5&amp;background=EBF4FF`} alt={name} />)}
                                                            </a>
                                                       </td>
                                                       <td>
                                                            <a href="#">
                                                                 <p className="mb-2 md:ml-4">{name} <span className="text-xs text-gray-500">({code})</span></p>
                                                                 {packs && (<span className="ml-4 text-xs text-gray-600">{packs.join(' | ')}</span>)}
                                                            </a>
                                                       </td>
                                                       <td className="justify-center mt-6 text-center font-semibold">
                                                            {quantity}
                                                       </td>
                                                       <td className="hidden text-right md:table-cell">
                                                            {(newprice != 0) && (<div>
                                                                 <span className="w-full text-sm text-gray-400 font-medium line-through">{currency} {price.toFixed(2)}</span><br />
                                                                 <span className="w-full text-sm lg:text-base font-medium text-emerald-700">{currency} {newprice.toFixed(2)}</span>
                                                            </div>)}
                                                            {(newprice == 0) && (<div>
                                                                 <span className="w-full text-sm lg:text-base font-medium">{currency} {price.toFixed(2)}</span><br />
                                                            </div>)}
                                                       </td>
                                                       <td className="text-right">
                                                            {(newprice != 0) && (<span className="text-sm lg:text-base font-medium">{currency} {(newprice * quantity).toFixed(2)}</span>)}
                                                            {(newprice == 0) && (<span className="text-sm lg:text-base font-medium">{currency} {(price * quantity).toFixed(2)}</span>)}
                                                       </td>
                                                  </tr>
                                             })}
                                        </tbody>
                                   </table>
                                   <div className="w-full md:flex md:justify-between mt-2 pt-4">
                                        <div className="w-full md:w-1/2">
                                             <p className="w-full mb-2 font-bold text-gray-700">{data.cart.caption.pickUp_title}</p>
                                             <div className="w-full p-2 rounded">
                                                  <label className="text-sm">{data.cart.caption.fnameId}</label>
                                                  <p className="font-medium">{values.name}</p>
                                             </div>
                                             <div className="w-full p-2 rounded">
                                                  <label className="text-sm">{data.cart.caption.phone}</label>
                                                  <p className="font-medium">{values.phone}</p>
                                             </div>
                                             <div className="w-full p-2 rounded">
                                                  <label className="text-sm">{data.cart.caption.pickup}</label>
                                                  <p className="text-sm">{values.address}</p>
                                                  <p className="font-medium">{values.destination}</p>
                                             </div>
                                        </div>
                                        <div className="w-full md:w-1/2 rounded bg-gray-100 p-4">
                                             <div className="flex justify-between border-b">
                                                  <div className="lg:px-4 lg:py-2 m-1 text-md lg:text-lg font-semibold text-center text-gray-600">
                                                       {data.cart.caption.amount}
                                                  </div>
                                                  <div className="lg:px-4 lg:py-2 m-1 lg:text-md font-semibold text-center text-gray-600">
                                                       {data.cart.currency} {data.cart.amount.toFixed(2)}
                                                  </div>
                                             </div>
                                             <div className={`flex justify-between pt-1 border-b ${(data.cart.destination && data.cart.enable_delivery)?'':'hidden'}`}>
                                                  <div className="lg:px-4 lg:py-2 m-2 text-md lg:text-lg font-semibold text-center text-gray-600">
                                                       {data.cart.caption.delivery}
                                                  </div>
                                                  <div className="lg:px-4 lg:py-2 m-2 lg:text-md font-semibold text-center text-gray-600">
                                                       {data.cart.currency} {data.cart.delivery.toFixed(2)}
                                                  </div>
                                             </div>
                                             <div className="flex justify-between pt-1 border-b">
                                                  <div className="lg:px-4 lg:py-2 m-2 text-md lg:text-lg font-semibold text-center text-gray-600">
                                                       Total
                                                  </div>
                                                  <div className="lg:px-4 lg:py-2 m-2 lg:text-md font-bold text-center text-gray-900">
                                                       {data.cart.currency} {data.cart.total.toFixed(2)}
                                                  </div>
                                             </div>
                                             <a href={data.cart.pay_info.url} className="flex justify-center w-full px-10 py-3 mt-6 font-medium text-white uppercase bg-emerald-800 rounded-full shadow item-center hover:bg-emerald-600 focus:shadow-outline focus:outline-none">
                                                  <img src={data.cart.pay_info.logo} alt={data.cart.pay_info.name} className="w-6 mr-4" /> {data.cart.caption.pay}
                                             </a>
                                        </div>
                                   </div>
                              </div>
                    </div>
               </div>)}
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
CheckOut.layout = page => <UserLayout children={page} header={'CheckOut'} />;

export default CheckOut;
